// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"4df1e6a0","352":"b3271cea","413":"bf65c68d","453":"d298abf4","848":"9f2b0ce0","892":"b1f9fac6","973":"486d26d2"}[chunkId] + ".chunk.js";
};